import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/primeng';

@Pipe({
  name: 'lotacoespipe'
})
export class LotacoesPipe implements PipeTransform {
  transform(value: any[]): any {
    let usuarioLotacaoPerfil: any = [];
    let lotacoes: any = [];
    let retornoFinal: any = [];

    value.forEach(
      x => {
        usuarioLotacaoPerfil.push(x)
        if(x.id_lotacao != undefined){
          usuarioLotacaoPerfil.forEach(x => {
            if(lotacoes.find(y => y == x.id_lotacao)){ } else {
              if(x.id_status == 2 && x.data_exclusao == null){
                retornoFinal.push(x)
                lotacoes.push(x.id_lotacao)
              }
            }
          });
        }
      }
    );

    return retornoFinal;
  }
}


// WEBPACK FOOTER //
// ./src/app/util/lotacoes.pipe.ts